/**
 * App route paths in Spanish (no /admin prefix).
 * `LEGACY_PATH_REDIRECTS` keeps old English and /admin URLs working.
 */
const routes = {
  authCallback: '/auth/callback',
  dashboard: '/inicio',
  login: '/ingresar',
  register: '/registro',
  onboarding: '/bienvenida',
  pensionCalculations: '/pensiones',
  pensionCalculationsEdit: '/pensiones/editar',
  logs: '/bitacora',
  help: '/ayuda',
  support: '/soporte',
  pensionUsers: '/usuarios',
  pensionUserDetail: '/usuarios/:userId',
  preferences: '/preferencias',
  utm: '/utm',
  utmNew: '/utm/nuevo',
  landing: '/landing',
  privacy: '/privacidad',
  terms: '/terminos',
  pet: '/pet/policy',
  petPolicy: '/pet-circle/policy',
  root: '/',
  sticky: '/labs/sticky',

  // --- Backward-compatible aliases (same paths, old key names) ---
  adminAuthCallback: '/auth/callback',
  adminDashboard: '/inicio',
  adminLogin: '/ingresar',
  adminLoginSupabase: '/ingresar',
  adminPensionCalculations: '/pensiones',
  adminPensionCalculationsEdit: '/pensiones/editar',
  adminLogs: '/bitacora',
  adminHelp: '/ayuda',
  adminSupport: '/soporte',
  adminPensionUser: '/usuarios',
  adminPensionUserDetail: '/usuarios/:userId',
  adminPreferences: '/preferencias',
  adminUtm: '/utm',
  adminUtmNew: '/utm/nuevo',
}

/** Old URLs → current Spanish paths (bookmarks, ACL, and English slugs). */
export const LEGACY_PATH_REDIRECTS = [
  ['/admin/login', routes.login],
  ['/admin/login-supabase', routes.login],
  ['/login', routes.login],
  ['/admin/dashboard', routes.dashboard],
  ['/dashboard', routes.dashboard],
  ['/admin/preferences', routes.preferences],
  ['/preferences', routes.preferences],
  ['/admin/utm', routes.utm],
  ['/admin/utm/new', routes.utmNew],
  ['/utm/new', routes.utmNew],
  ['/admin/pension/usuarios', routes.pensionUsers],
  ['/pension/usuarios', routes.pensionUsers],
  ['/users', routes.pensionUsers],
  ['/admin/pension/calculations', routes.pensionCalculations],
  ['/pension/calculations', routes.pensionCalculations],
  ['/admin/pension/calculations/edit', routes.pensionCalculationsEdit],
  ['/pension/calculations/edit', routes.pensionCalculationsEdit],
  ['/admin/logs', routes.logs],
  ['/logs', routes.logs],
  ['/admin/ayuda', routes.help],
  ['/admin/support', routes.support],
  ['/support', routes.support],
  ['/onboarding', routes.onboarding],
]

/** @deprecated Use LEGACY_PATH_REDIRECTS */
export const LEGACY_ADMIN_REDIRECTS = LEGACY_PATH_REDIRECTS

const LEGACY_PATH_MAP = Object.fromEntries(LEGACY_PATH_REDIRECTS)

/** Map a legacy English or `/admin/...` path to the current route (ACL menus, deep links). */
export const normalizeAppPath = (path) => {
  if (!path || typeof path !== 'string') return path
  return LEGACY_PATH_MAP[path] || path
}

export default routes
